import React from 'react';
import reactDom from '../../common/react/dom/index';
import NewsHomeContainer from '../../components/frontend/homepage/NewsHomeContainer';
import ContentsContainer from '../../components/frontend/informativehome/ContentsContainer';

export default function init() {
	reactDom(<NewsHomeContainer size={5} />, 'js-react-list');
	reactDom(<ContentsContainer size={10} />, 'js-react-video');
}
